/* eslint-disable */
// Custom queries — kept outside queries.js so amplify codegen does not remove them.

/** Fallback search when resolutionStatus is not deployed yet. */
export const searchAdminErrorLogsCompat = /* GraphQL */ `
  query SearchAdminErrorLogsCompat(
    $filter: SearchableAdminErrorLogFilterInput
    $sort: SearchableAdminErrorLogSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchAdminErrorLogs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        sharedAppId
        requestId
        error
        formUrl
        clientId
        integrator
        organizationId
        initiative
        requesterEmail
        partnerPrimaryContactEmail
        salesforceAccountOwnerEmail
        salesforceId
        salesforceUrl
        accountName
        slackChannelRoute
        notifySlack
        notifyEmail
        emailTemplateId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;

export const emailsByAdminErrorLogId = /* GraphQL */ `
  query EmailsByAdminErrorLogId(
    $adminErrorLogId: String
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    emailsByAdminErrorLogId(
      adminErrorLogId: $adminErrorLogId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        adminErrorLogId
        clientId
        emailTemplateId
        toEmails
        ccEmails
        mode
        source
        sesMessageId
        subject
        sentAt
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
